import { Entity, Column, PrimaryGeneratedColumn, OneToMany, Index, ManyToOne, JoinColumn } from 'typeorm'

import AudienceDemographic from './AudienceDemographic'
import SurveyAudience from './SurveyAudience'
import Survey, { StatusChangeSource } from './Survey'
import RespondentSurvey from '../RespondentSurvey'
import RespondentSession from '../RespondentSession'
import SurveyEvent from './SurveyEvent'

export enum AudienceStatus {
  ACTIVE='active',
  INACTIVE='inactive',
  DRAFT='draft',
}
@Entity('audiences')
@Index(['accountId', 'segmentId'])
export default class Audience {
  @PrimaryGeneratedColumn('uuid')
  id!: string

  @Column({name: 'created_at'})
  createdAt!: Date

  @Column({name: 'updated_at'})
  updatedAt!: Date

  @Column({ nullable: true, name: 'account_id'})
  accountId?: string

  @Column({ nullable: true, name: 'organization_id' })
  organizationId?: string

  @Column({name: 'segment_id'})
  segmentId!: string

  @Column({ type: 'enum', enum: AudienceStatus, name: 'status' })
  status!: AudienceStatus

  @Column({name: 'qtest_tap_id'})
  @Index({ unique: true })
  qtestTapId!: string

  @Column({name: 'name'})
  name!: string

  @Column({name: 'has_screener'})
  hasScreener!: boolean

  @Column({ nullable: true, name: 'qtest_previous_audience_id_ref'})
  qtestPreviousAudienceIdRef?: string

  @Column({ nullable: true, name: 'qtest_next_audience_id_ref' })
  qtestNextAudienceIdRef?: string

  @Column({ nullable: true, name: 'prev_audience_id' })
  prevAudienceId?: string

  @Column({ nullable: true, name: 'next_audience_id' })
  nextAudienceId?: string

  @Column({name: 'archived' })
  archived!: boolean

  @Column({ nullable: true, name: 'custom_description' })
  customDescription?: string

  @Column({name: 'is_international' })
  isInternational!: boolean

  @Column({name: 'submitted_by' })
  submittedBy!: string

  @Column({name: 'qtest_uid' })
  qtestUid!: string

  @OneToMany(type => AudienceDemographic, audienceDemographic => audienceDemographic.audience)
  demographics?: AudienceDemographic[]

  @OneToMany(type => SurveyAudience, s => s.audience)
  surveyAudiences!: SurveyAudience[]

  @ManyToOne(type => Survey)
  @JoinColumn({ name: 'screener_survey_id' })
  screenerSurvey?: Survey

  @OneToMany(type => RespondentSurvey, s => s.audience)
  respondentSurveys!: RespondentSurvey[]

  // This association is deprecated in favor of a new RespondentOrders table
  // that tracks the Audience ID.
  @OneToMany(type => RespondentSession, r => r.audience)
  respondentSessions!: RespondentSession[]

  @Column({ name: 'status_change_source', type: 'enum', enum: StatusChangeSource, nullable: true })
  statusChangeSource?: StatusChangeSource

  @OneToMany(type => SurveyEvent, se => se.audience)
  surveyEvents!: SurveyEvent[]
}
